import { SilentRequest } from "@azure/msal-browser";
import { msalInstance } from "..";

/**
 * Acquires an access token for a specific API.
 *
 * The scope matters: a token is audience-scoped, so lazerhub and the JEPX data
 * provider each need their own. Asking MSAL for a different `scopes` array
 * returns a different token from the same signed-in account rather than
 * re-prompting, so calling this per API is cheap.
 *
 * On silent failure this redirects to login and rethrows — the redirect
 * navigates away, so nothing after the throw runs.
 */
export const acquireToken = async (
  request: Pick<SilentRequest, "scopes">
): Promise<string> => {
  const account = msalInstance.getAllAccounts()[0];

  if (!account) {
    throw new Error("No active account found in MSAL instance");
  }

  const accessTokenRequest = {
    ...request,
    account: account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return response.accessToken;
  } catch (e) {
    console.error("Silent token acquisition failed. Redirecting to login. ", e);
    msalInstance.acquireTokenRedirect(accessTokenRequest);
    throw e;
  }
};
